/**
 * Outil « Logique et ensembles » (Boîte à outils, 2nde → prépa).
 *
 * Ensembles (diagramme de Venn dans E = {1, …, 12}), tables de vérité (deux
 * formules comparées : contraposée, réciproque, Morgan…) et quantificateurs
 * (pour tout, il existe, contre-exemple, négation ; deux variables en prépa).
 */

import { useState } from 'react';
import { schoolLevelRank } from '@jeraisonne/db/cards';
import type { ToolProps } from '../../tool-types';
import { Segmented } from '../../ui/controls';
import { QuantMode } from './quant-mode';
import { SetsMode } from './sets-mode';
import { TruthMode } from './truth-mode';

type Mode = 'sets' | 'truth' | 'quant';

const MODES: ReadonlyArray<{ value: Mode; label: string }> = [
  { value: 'sets', label: 'Ensembles' },
  { value: 'truth', label: 'Vérité' },
  { value: 'quant', label: 'Quantificateurs' },
];

export function LogicTool({ level }: ToolProps & { level?: string | null }) {
  const rank = Math.min(9, Math.max(5, schoolLevelRank(level) ?? 9));
  const [mode, setMode] = useState<Mode>('sets');
  return (
    <div className="space-y-4">
      <Segmented ariaLabel="Ce qu’on regarde" value={mode} options={MODES} onChange={setMode} />
      {mode === 'sets' && <SetsMode />}
      {mode === 'truth' && <TruthMode rank={rank} />}
      {mode === 'quant' && <QuantMode rank={rank} />}
    </div>
  );
}
